import { BaseModel } from "sjs-base-model";
import AgentModel from "./creditoNet/AgentModel";

export default class SimulazioneRichiestaCedibilitaTableModel extends BaseModel {
    public readonly idTransferRequestInfo: number = 0;
    public readonly idTransferRequest: string = "";
    public readonly protocolNumber: string = "";
    public readonly authority: string = "";
    public readonly taxCode: string = "";
    public readonly name: string = "";
    public readonly date: string = "";
    public readonly state: string = "";
    public readonly amount: number = 0;
    public readonly agent: AgentModel = new AgentModel({});

    constructor(data: Partial<SimulazioneRichiestaCedibilitaTableModel>) {
        super();

        this.update(data);
    }
}
